import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'profiles-component',
  template: require('./profiles.component.html'),
  styles: [require('./profiles.component.scss')]
})
export class ProfilesComponent implements OnInit {

  constructor() {
    // Do stuff
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/profiles/profiles.component.ts